import React, { useState } from "react";

import DatePicker from "react-datepicker";

import DateUtil from "../../common/dateUtil";
import CheckboxList from "../common/controls/CheckboxList";


const ObaSearchCriteriaComp = (props)=>{

    let initFromDate = new Date(new Date());
    initFromDate.setDate(initFromDate.getDate() - 90);
  
    const initFormData = {
        contribType: "",
        fromDate: initFromDate,
        toDate: new Date(),
        reqStatus: "",
      };


      const [reqStates, setReqStates] = useState([
        { name: "reqState_Approved", key: "APPROVED", label: "Approved", checked: true },
        { name: "reqState_Pending", key: "PENDING", label: "Pending", checked: true },
        { name: "reqState_Rejected", key: "REJECTED", label: "Rejected", checked: true },
        { name: "reqState_Withdrawn", key: "WITHDRAWN", label: "Withdrawn", checked: true }
      ]);

      const [contribTypes,setContribTypes] = useState([
        {
          name: "contribType_Contribution",
          key: "Contribution",
          label: "Political Contribution",
          checked: true,
        },
        {
          name: "contribType_Donation",
          key: "Donation",
          label: "Charitable Donations",
          checked: true,
        }        
      ]);





      const [formData, setFormData] = useState(initFormData);
        

      const [validation, setValidation] = useState({
        valid:true,
        reqStatus: true,
        contribType:true
      });
    

    const handleReqStateChange = (e) => {
        const itemName = e.target.name;
        const isChecked = e.target.checked;
        setReqStates((p) => {
        return p.map((item) => {
            return item.name === itemName ? { ...item, checked: isChecked } : item;
        });
        });
    };

    
    const handleContribTypeChange = (e) => {
      const itemName = e.target.name;
      const isChecked = e.target.checked;
      setContribTypes((p) => {
        return p.map((item) => {
            return item.name === itemName ? { ...item, checked: isChecked } : item;
        });
      });
  };

    const handleFromDateChange = (date) => {
        setFormData({ ...formData, fromDate: date });
    };

    const handleToDateChange = (date) => {
        setFormData({ ...formData, toDate: date });
    };


    const geCheckedStr = (obj) => {
        const selected = obj.filter((p) => {
          return p.checked === true;
        });
    
        const ta = selected.map((p) => {
          return p.key;
        });
    
        return ta.join();
      };

    const validateForm = (strStatus,strContribTpes) => {
        const valid = strStatus && strContribTpes? true : false;
        setValidation({
          ...validation,
          valid,
          reqStatus: strStatus ? true : false,
          contribType: strContribTpes ? true : false
        });
        return valid;
    };


    const handleSearchClick = () => {
        const statesStr = geCheckedStr(reqStates);
        const contribTypesStr = geCheckedStr(contribTypes);
    
        if (!validateForm(statesStr,contribTypesStr)) {
          return;
        }
    
        let fromDate = DateUtil.toIsoStrDate(formData.fromDate);
        let toDate = DateUtil.toIsoStrDate(formData.toDate);
    
        let jsonData = {
          ...formData,
          reqStatus: statesStr,
          fromDate: fromDate,
          toDate: toDate,
          contribTypes:contribTypesStr
        };
        props.onSearch(jsonData);
      };


    return (
    <div className="form">
        <div className="form-header">
            <div className="form-header-label">Filter & Display</div>
        </div>
        
        <div className="form-body">
            <div className="form-items">

                <div className="form-columns">
                    
                    <div className="form-column"> 
                        
                      <div className="form-item">
                          <label className={`form-item-label required ${validation.contribType ? "" : "warning"}`}>
                              Contribution/Donation:
                          </label>
                          <div className="form-item-value label-group">
                                <CheckboxList items={contribTypes} handleChange={handleContribTypeChange}/>
                          </div>
                      </div>

                    </div>

                    <div className="form-column"> 
                        
                        <div className="form-item">
                            <label className={`form-item-label required ${validation.reqStatus ? "" : "warning"}`}>Request Status:</label>
                            <div className="form-item-value label-group">
                                <CheckboxList items={reqStates} handleChange={handleReqStateChange}/>
                            </div>
                        </div>

                        <div className="form-item splitted">
                            <div className="flex flex-1 mr-3">
                            <label className="form-item-label-short">From Date:</label>
                            <div className="form-item-value-short">
                                <DatePicker
                                selected={formData.fromDate}
                                onChange={handleFromDateChange}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                />
                            </div>
                            </div>

                            <div className="flex flex-1">
                            <label className="form-item-label-short">To Date:</label>
                            <div className="form-item-value-short">
                                <DatePicker
                                selected={formData.toDate}
                                onChange={handleToDateChange}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                />
                            </div>
                            </div>
                        </div>


                    </div>




                </div>
            
            </div>
        </div>

        <div className="form-footer">
            {validation.valid ? (
            <div className="form-status"></div>
            ) : (
                <div className="form-status error">Enter Required Information</div>
            )}

            <div className="btn-group">
            <button
                id="btnLoadProductDetail"
                type="button"
                className="btn btn-primary"
                onClick={handleSearchClick}
            >
                Search
            </button>
            </div>
      </div>


    </div>
    );
};

export default ObaSearchCriteriaComp;


